var exports = {
  "k": "TimestampWithTooltip.module__container___Nk1DaV",
  "N": "TimestampWithTooltip.module__hiddenSpacer___Nk1DaV",
};

module.exports = exports;
